






























import Vue, { PropOptions } from 'vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
export type IOption = iso;
import * as models from '@/class/models/views/graph';
import ModalBase from '@/components/util/ModalBase.vue';
import InfiniteLoading from 'vue-infinite-loading';
import API from '@/api/common';

export default Vue.extend({
  name: 'ListDetail',
  components: { ModalBase, InfiniteLoading },
  props: {
    values: Object as PropOptions<models.IValues>,
  },
  data() {
    return {
      myValues: {} as models.IValues,
      items: [] as any[],
      fields: [] as any[],
      dl: false,
      infiniteId: 0,
      selectMaxCount: 0,
      nextPage: 0,
      title: '',
      loading: true,
      downloading: false,
    };
  },
  async mounted() {
    this.myValues = this.values;
    this.dl = false;
    const api = new API();
    if (!this.myValues.dateto) {
      const resTerm = await api.post<models.IValues, models.IValues>('gadget/term', this.values);
      if (resTerm.result) {
        this.myValues = resTerm.data;
      }
    }
    // infiniteLoading開始
    this.loading = false;
    (this.$refs.infiniteLoading as any).stateChanger.reset();
  },
  methods: {
    async infiniteHandler($state: any) {
      // 無限ローディング対策
      if (!this.loading) {
        this.loading = true;
        const api = new API();
        const requestData = {
          values: this.myValues,
          page: this.nextPage,
        };

        // console.log(requestData);
        const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);

        if (res.result) {
          if (this.nextPage === 0) {
            this.dl = true;
            this.fields = res.data.fileds;
            this.title = res.data.title;
          }
          this.items = this.items.concat(res.data.items);
          this.selectMaxCount = res.data.count;

          // console.log(res.data.count);
          if (this.items.length < this.selectMaxCount) {
          // if (false) {
            $state.loaded();
          } else {
            $state.complete();
          }
          this.nextPage++;
        }
        this.loading = false;
      }
    },
    async onClickDownLoad() {
      if (this.downloading) {
        return;
      }
      this.downloading = true;
      const api = new API();
      const requestData = {
        values: this.myValues,
        page: 0,
        csv: true,
      };
      const res = await api.post<any, any>('gadget/basic_graph/detail', requestData);
      this.downloading = false;
      if (res.result) {
        // console.log(res.data);
      }
    },
  },
});
